import React from 'react';
import { FormApi } from '@/form/FormProvider.tsx';

export const FormContext = React.createContext<FormApi | null>(null);
